import meta from '../metas/select-multiple';
import Select from './select';
export default {
  meta,
  functional: true,

  render(h, context) {
    // 复用下拉单选组件，添加多选属性
    context.data.attrs.multiple = true; // 将value从字符串改成数组

    const {
      value
    } = context.data.attrs;

    if (typeof value === 'string') {
      context.data.attrs.value = value ? value.split(',') : [];
    }

    return h(Select, context.data, context.children);
  }

};